// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VMqi","controls":"styles_controls__3XkUx","charLimit":"styles_charLimit__3Z8qH","input":"styles_input__2LyYG","send":"styles_send__1-8aw"};